import luckyDrawReward from '@/api/lucky-draw/lucky-draw-reward'

import { baseState, baseMutations } from '@/store/mixins'
// import moment from 'moment'
import { split } from 'lodash';

export const state = {
	...baseState,
	formViewData: [],
	report_type: "1",
	event_id: [],
	is_spinned: 0,
	dateRange: [],
	branch_id: [],
	location_id: [],
	sale_id: [],
	item_id: [],
	branchs: [],
	locations: [],
}

export const getters = {
	getItem: state => ({ chosenItem, search = '' } = {}) => {
		if (chosenItem !== undefined) {
			return (
				state.formViewData.luckyDrawItems
					.filter(p =>
						!_.includes(chosenItem.map(el => el.item_id), p.item_id)
					)
					.filter(p =>
						search.split(' ').every((s) => p.item_name_en.toLowerCase().includes(s.toLowerCase())) ||
						search.split(' ').every((s) => p.item_name_kh.toLowerCase().includes(s.toLowerCase()))
					)
					.slice(0, 100)
			)
		}
		return state.formViewData.luckyDrawItems.slice(0, 100);
	},
	findItem: state => itemId => {
		if (!itemId) {
			return {
				item_name_en: null,
				item_name_kh: null
			}
		}
		return state.formViewData.luckyDrawItems.find(p => p.item_id == itemId)
	},
}

export const mutations = {
	...baseMutations,
	SET_VIEW_MODELS(state, { data, index }) {
		if (!index) {
			state.formViewData = data;
		} else {
			split(index, ",").forEach(el => {
				state.formViewData[el] = data[el];
			});
		}
	},
	SET_REPORT_TYPE(state, data) {
		state.report_type = data
	},
	SET_EVENT_ID(state, data) {
		state.event_id = data
	},
	SET_IS_SPINNED(state, data) {
		state.is_spinned = data
	},
	RESET_STATE(state) {
		state.report_type = "1"
		state.event_id = []
		state.is_spinned = 0
	},
	SET_DATE_RANGE(state, date) {
		state.dateRange = date
	},
	SET_BRANCH_ID(state, data) {
		state.branch_id = data
	},
	SET_LOCATION_ID(state, data) {
		state.location_id = data
	},
	SET_BRANCHS(state, data) {
		state.branchs = data
	},
	SET_LOCATIONS(state, data) {
		state.locations = data
	},
	SET_SALE_ID(state, data) {
		state.sale_id = data
	},
	SET_ITEM_ID(state, data) {
		state.item_id = data
	},
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				report_type: context.state.report_type,
				branch_id: context.state.branch_id,
				location_id: context.state.location_id,
				filter: {
					id: context.state.event_id,
					spinned: context.state.is_spinned,
					sale_id: context.state.sale_id,
					item_id: context.state.item_id,
					date_between: _.join(context.state.dateRange, ','),
					search: context.state.search,
				}
			},
			attrubutes
		)
		return luckyDrawReward.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	store(context, data) {
		return luckyDrawReward.store(data)
	},
	update(context, { id, data }) {
		return luckyDrawReward.update(id, data)
	},
	async find(context, id) {
		if (_.isEmpty(context.state.edit_data)) {
			let response = await luckyDrawReward.find(id)
			context.commit('SET_EDIT_DATA', response.data)
		}
	},
	destroy(context, id) {
		return luckyDrawReward.destroy(id)
	},
	async getFormViewData(context, { params, index }) {
		let response = await luckyDrawReward.formModel({ params: params });
		context.commit("SET_VIEW_MODELS", {
			data: response.data,
			index: index
		});
		return Promise.resolve(response);
	},
	exportExcel(context) {
		return luckyDrawReward.exportExcel({
			report_type: context.state.report_type,
			branch_id: context.state.branch_id,
			location_id: context.state.location_id,
			id: context.state.event_id,
			spinned: context.state.is_spinned,
			sale_id: context.state.sale_id,
			item_id: context.state.item_id,
			date_between: context.state.dateRange,
			search: context.state.search,
		})
	},
	changeOrders(context, data) {
		return luckyDrawReward.changeOrders(data)
	},
}
